<div class="container px-0">
  <div id="mainFreightCharacteristics" class="col-md-12 mb-md-0 mb-12">
    <div class="row">
      <div class="col-md-12 mb-md-0 mb-12">
        <label class="title mb-3">
          ¿Cuántos vehículos necesita?
        </label>
      </div>
      <p class="font-weight-normal col-12 f-14">
        La cantidad de vehículos que escoja equivale al número de servicios de transporte a realizar
      </p>
      <div class="col-md-12 mb-md-0 mb-12 mt-3" *ngIf="vehiclesFormArray.length">
        <div class="cards-grid">
          <div class="vehicle-card mb-3" *ngFor="let vehicleGroup of vehiclesFormArray.controls; let i = index">
            <div class="vehicle-card__header">
              <div class="vehicle-card__icon">
                <img [src]="getIconVehicle(manualCreationCargoService.vehiclesSelected[i])"
                  (error)="onErrorRenderImage($event)" alt="">
              </div>
              <div class="vehicle-card__title">
                {{ getVehicleDisplayName(i) }}
              </div>
            </div>
            <div class="vehicle-card__content row">
              <div class="col-lg-6 mb-md-0 mb-2">
                <mat-form-field appearance="outline">
                  <mat-label>Cantidad<span class="asterisk">*</span></mat-label>
                  <input type="number" matInput min="1" [formControl]="vehicleGroup.get('quantity')">
                  <mat-error *ngIf="vehicleGroup.get('quantity')?.errors?.required">
                    {{ utils.giveMessageError('MANDATORY_FIELD') }}
                  </mat-error>
                  <mat-error *ngIf="vehicleGroup.get('quantity')?.errors?.min">
                    {{ utils.giveMessageError('MIN_VALUE_NOT_REACHED_SHORT', 'Cantidad', minQuantity) }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-6 mb-md-0 mb-4">
                <app-vehicle-body-work-type [inputFormControl]="vehicleGroup.get('bodyworkType')"
                  [options]="bodyworkOptions[i]" [validate]="formValidate"></app-vehicle-body-work-type>
              </div>
              <mat-form-field appearance="outline" class="col-lg-6 mb-md-0 mb-2" *ngIf="showEnvironmentControl(i)">
                <mat-label>Tipo de ambiente<span class="asterisk">*</span></mat-label>
                <mat-select [formControl]="vehicleGroup.get('environment')">
                  <mat-option *ngFor="let environmentType of environmentTypes" [value]="environmentType">
                    {{environmentType}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="vehicleGroup.get('environment')?.errors?.required">
                  {{ utils.giveMessageError('MANDATORY_FIELD') }}
                </mat-error>
              </mat-form-field>
              <div class="col-12 d-flex flex-wrap p-0" *ngIf="showTrailerInfo(i)">
                <div class="col-lg-6">
                  <app-vehicle-body-work-type [inputFormControl]="vehicleGroup.get('trailerBodywork')"
                    [options]="trailerOptions[i]" [validate]="formValidate"></app-vehicle-body-work-type>
                </div>
                <mat-form-field appearance="outline" class="col-lg-6">
                  <mat-label>Número de ejes del tráiler<span class="optional">(opcional)</span></mat-label>
                  <input type="number" min="2" matInput [formControl]="vehicleGroup.get('trailerAxles')">
                  <mat-error *ngIf="vehicleGroup.get('trailerAxles')?.errors?.min">
                    {{ utils.giveMessageError('MIN_VALUE_NOT_REACHED_SHORT', 'N° de ejes del tráiler', minAxles) }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 button-container justify-content-center my-3">
        <button mat-raised-button class="secondary-sharp mr-4" (click)="stepBack()">Atrás</button>
        <app-request-button></app-request-button>
        <button mat-raised-button color="primary" class="bg-color-primary" (click)="nextStep()">Siguiente</button>
      </div>
    </div>
  </div>
</div>